(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funnel-barra-cta"] && !Shopify.designMode) return;
  try {
    
  class FunnelStickyBar extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold || 25) / 100;
      this.hidden = false;

      const close = this.querySelector('[data-fn-close]');
      if (close) {
        close.addEventListener('click', () => {
          this.classList.remove('is-visible');
          this.dismissed = true;
        });
      }

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.dismissed) return;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      const progress = window.scrollY / scrollable;
      this.classList.toggle('is-visible', progress >= this.threshold);
    }
  }

  if (!customElements.get('funnel-sticky-bar')) {
    customElements.define('funnel-sticky-bar', FunnelStickyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funnel-testimonios-video"] && !Shopify.designMode) return;
  try {
    
  class FunnelVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.trigger = this.querySelector('[data-fn-play]');
      if (!this.video || !this.trigger) return;

      this.trigger.addEventListener('click', () => {
        this.trigger.hidden = true;
        this.video.setAttribute('preload', 'auto');
        const playback = this.video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(() => {
            this.trigger.hidden = false;
          });
        }
      });

      this.video.addEventListener('pause', () => {
        if (this.video.currentTime === 0) this.trigger.hidden = false;
      });
    }
  }

  if (!customElements.get('funnel-video')) {
    customElements.define('funnel-video', FunnelVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
